var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 315,
    viewBox: "0 0 1728 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_2970)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 315,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.514648,
    width: 1728,
    height: 314.755,
    fill: "url(#paint0_linear_214_2970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.4 0.373336L976.62 210.9L1198.88 153.185L1301.25 275.942L1115.19 315.256L856.694 315.256L806.194 315.256L793.653 299.724L882.258 89.7304L920.309 0.373325L959.332 0.37333L1076.4 0.373336Z",
    fill: "url(#paint1_linear_214_2970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.484375V315.27H954.127C975.838 287.114 1017.5 101.08 862.587 1.5268L0 -0.484375Z",
    fill: "url(#paint2_linear_214_2970)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_2970",
    x1: 0,
    y1: 157.892,
    x2: 1728,
    y2: 157.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AAD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_2970",
    x1: 1126.19,
    y1: -98.9224,
    x2: 976.91,
    y2: 456.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AE30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_2970",
    x1: 0,
    y1: 157.393,
    x2: 976,
    y2: 157.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3493B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_2970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 315,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainer);
export default __webpack_public_path__ + "static/media/trainer.2c6f1fc2dd0836192fe6c0b06cb3008b.svg";
export { ForwardRef as ReactComponent };